// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__TqI_H","notes":"Notes_notes__34qfs","note":"Notes_note__1ZCXe","markdown":"Notes_markdown__2N65a"};